
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Innovacrystataxi() {



    const cardData =
    {
        keyword: ' Innova Crysta Taxi',
        heading: 'Prince Cabs: Innova Crysta Taxi',
        headingDescription: 'Prince Cabs provides premium Innova Crysta Taxi services, perfect for luxury family travel, corporate tours, airport transfers, and outstation journeys. Our Innova Crysta vehicles are spacious, well-maintained, and equipped with modern amenities to ensure a safe and comfortable ride. With professional chauffeurs, transparent fares, and on-time service, we make your travel smooth and stress-free. Experience reliability, comfort, and affordability with Prince Cabs’ trusted Innova Crysta taxi service in Pune and beyond.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was once the seat of the powerful Peshwas of the Maratha Empire. Though much of it was destroyed by fire in 1828, its grand gates, massive walls, and sprawling gardens still stand tall. The evening light-and-sound show brings alive tales of Maratha bravery. Visitors enjoy exploring its ruins and imagining its glorious past. It is a must-visit landmark for history lovers in Pune. Shaniwar Wada is the perfect blend of legend and architecture."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, built in 1892, is an architectural marvel with deep historical importance. During the Quit India Movement, Mahatma Gandhi, Kasturba Gandhi, and Sarojini Naidu were imprisoned here. The palace now houses a museum with artifacts, photos, and personal belongings of Gandhi. Its sprawling gardens provide a peaceful retreat for visitors. It is a national monument of pride and sacrifice. The palace stands as a timeless reminder of India’s freedom struggle."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, about 30 km from Pune, is a historic hill fortress famous for the 1670 Battle of Sinhagad. The fort’s ruins, bastions, and watchtowers tell stories of Maratha valor. Trekkers enjoy scenic routes, especially during monsoon when the hills turn lush green. From the summit, panoramic views of the Sahyadris are breathtaking. Local vendors sell traditional pithla-bhakri, adding to the fort experience. It is a favorite among history enthusiasts and nature lovers."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous religious landmark, dedicated to Lord Ganesha. The idol is adorned with gold and jewels, attracting thousands of devotees daily. During Ganesh Chaturthi, the temple is decorated with grandeur and cultural programs. It is also involved in various charitable activities. The temple’s central location makes it easily accessible. It is both a spiritual and cultural icon of Pune."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill, one of Pune’s highest points, offers panoramic views of the entire city. At its summit lies the Parvati Temple complex, dedicated to Lord Shiva and Goddess Parvati. The climb of more than 100 steps is rewarding with peace and spirituality at the top. The Peshwa Museum nearby adds historical depth. Sunrises and sunsets from the hill are especially captivating. It is a serene escape from the city’s hustle."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. It features massive pillars, a stone-carved Nandi, and an unfinished mandapa. Despite being in the city center, it offers a peaceful environment. The temple is a fine example of Rashtrakuta-era architecture. Visitors often come here for meditation and photography. It remains a hidden gem in Pune’s heritage map."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove of over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include musical instruments, sculptures, everyday objects, and the recreated Mastani Mahal. The museum reflects the cultural richness of Maharashtra and India. It fascinates both art lovers and historians alike. Its three-storey building itself is a heritage attraction. It is one of Pune’s most unique museums."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "Osho International Meditation Resort in Koregaon Park is a world-renowned spiritual retreat. Visitors from across the globe come here for meditation, wellness therapies, and yoga. Surrounded by serene gardens and modern architecture, it offers a peaceful escape. The ashram promotes holistic well-being and personal growth. Its vibrant international community adds cosmopolitan charm. It is a unique blend of spirituality and modern lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity, located in Viman Nagar, is Pune’s largest lifestyle and shopping mall. It houses hundreds of international and Indian brands, offering a world-class retail experience. Entertainment includes multiplex cinemas, gaming zones, and live events. The mall also features a wide range of restaurants and cafés. Seasonal festivals like Diwali and Christmas add vibrancy. It is the ultimate hub for shopping, dining, and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located about 20 km from Pune, is a scenic spot surrounded by hills. The reservoir supplies water to the city and offers natural beauty. Families enjoy picnics, boating, and street food near the dam. Monsoon enhances its charm with mist and greenery. Evenings here are especially peaceful with cool breezes. It is a refreshing escape for city dwellers."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by Mulshi Dam, is a serene outstation spot near Pune. It is surrounded by Sahyadri hills, forests, and waterfalls. Visitors enjoy camping, nature walks, and photography here. During monsoon, the lake looks spectacular with overflowing water and lush valleys. Eco-resorts nearby offer a comfortable stay amidst nature. It is ideal for couples, families, and adventure seekers."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Located on Senapati Bapat Road, Chaturshringi Temple is one of Pune’s oldest and most revered shrines. Dedicated to Goddess Chaturshringi (Durga), it requires devotees to climb over 100 steps to reach the sanctum. The temple is especially grand during Navratri with vibrant celebrations. It attracts devotees from all over Maharashtra. The views from the hilltop add to its charm. It is both a spiritual and cultural landmark."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "This war memorial is dedicated to Indian soldiers who sacrificed their lives post-independence. It displays tanks, weapons, and war memorabilia. The museum inside narrates stories of India’s military history. Visitors attend the evening flag retreat ceremony, which is deeply moving. It is both educational and inspiring for families and students. The memorial instills pride and patriotism."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden, spread across 39 acres, is a lush botanical park in Pune. Managed by the Agri-Horticultural Society, it houses exotic trees, flower nurseries, and shaded walking paths. Families come here for picnics and relaxation. The annual flower show is a highlight for nature lovers. It is one of Pune’s oldest gardens with colonial-era history. A green oasis in the bustling city, it offers peace and tranquility."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, Pune’s highest hill, is a popular trekking and jogging destination. The hilltop offers panoramic views of the entire city. It is rich in biodiversity, with birds, trees, and fresh air. Fitness enthusiasts flock here for morning walks and cycling. Sunrises and sunsets from Vetal Hill are breathtaking. It is Pune’s natural lung and a much-needed retreat for nature lovers."
  }
],


"services": [
    {
        "name": "Innova Crysta Taxi Service",
        "description": "Experience premium Innova Crysta taxi service offering spacious and comfortable rides for both city travel and long-distance journeys. Our well-maintained vehicles come with professional drivers, ensuring safety, punctuality, and a luxurious travel experience for business trips, family outings, or special occasions."
    },
    {
        "name": "SUV Taxi",
        "description": "Reliable and comfortable SUV taxi services available for daily commutes, airport transfers, and outstation travel. Our SUVs are equipped with modern amenities and driven by experienced chauffeurs to provide you with a smooth and enjoyable ride every time."
    },
    {
        "name": "SUV Taxi Service",
        "description": "Professional SUV taxi service offering safe and hassle-free transportation for individuals, families, and groups. Whether you need an airport drop, local sightseeing, or long-distance travel, our SUV fleet is ready to meet all your needs with excellent customer support."
    },
    {
        "name": "SUV Cab Service",
        "description": "Premium SUV cab services tailored for comfort, style, and convenience. Perfect for group travels, business trips, and family outings, our cabs come with spacious seating, ample luggage space, and courteous drivers to make your journey seamless and pleasant."
    },
    {
        "name": "Innova Crysta Taxi Near Me",
        "description": "Find nearby Innova Crysta taxi services offering reliable and affordable rides at your convenience. With quick booking options and prompt pickups, our taxis ensure comfortable travel within Pune and to nearby destinations with trusted drivers and well-maintained vehicles."
    },
    {
        "name": "Innova Rent Rate",
        "description": "Competitive and transparent rental rates for Innova vehicles, available for daily, hourly, and outstation use. Our pricing is designed to offer excellent value, including options for short trips, long-distance travel, and customized tour packages with no hidden charges."
    },
    {
        "name": "Innova Car Taxi",
        "description": "Comfortable and spacious Innova car taxi services suitable for city rides, airport transfers, and outstation trips. Our drivers are professional and knowledgeable, ensuring you reach your destination safely and on time while enjoying a smooth ride."
    },
    {
        "name": "Innova Crysta Hire",
        "description": "Flexible Innova Crysta hire options available for short and long-term rentals. Whether it’s a corporate event, family vacation, or business trip, our fleet of well-maintained Innova Crysta vehicles and skilled drivers provide reliable and luxurious transportation."
    },
    {
        "name": "Innova 8 Seater on Rent",
        "description": "Rent a spacious 8-seater Innova, perfect for large groups and family outings. Enjoy comfortable seating, ample luggage space, and professional driver services to make your travel convenient and enjoyable for city tours or long-distance trips."
    },
    {
        "name": "Innova Cab Booking in Pune",
        "description": "Easy and quick Innova cab booking service in Pune with instant confirmation and flexible packages. Choose from hourly rentals, daily hires, or outstation trips with the assurance of safe and comfortable travel in well-maintained vehicles."
    },
    {
        "name": "Book a Toyota Innova in Pune",
        "description": "Reserve a Toyota Innova in Pune for your next journey, whether local or outstation. Our booking system offers a seamless experience with transparent pricing, professional drivers, and prompt pickups ensuring a stress-free travel experience."
    },
    {
        "name": "7 Seater Cab for Outstation",
        "description": "Spacious 7-seater cabs available for outstation trips, ideal for families and small groups. Enjoy comfortable rides with ample luggage space, experienced drivers, and competitive pricing for safe and reliable travel beyond city limits."
    },
    {
        "name": "Family Innova Crysta Taxi",
        "description": "Family-friendly Innova Crysta taxi service offering ample space, child safety features, and a smooth ride. Perfect for family outings, weekend trips, and vacations, with courteous drivers ensuring a comfortable and stress-free journey."
    },
    {
        "name": "Affordable Innova Crysta Cab",
        "description": "Get the best value with our affordable Innova Crysta cab services without compromising on comfort or safety. Suitable for all types of travel including airport transfers, local commuting, and outstation tours with competitive rates and transparent pricing."
    },
    {
        "name": "Innova Crysta Tour Package Booking",
        "description": "Book customized tour packages featuring Innova Crysta cabs for sightseeing, pilgrimage, and leisure trips. Enjoy flexible itineraries, comfortable vehicles, and professional drivers who make your travel experience smooth, enjoyable, and memorable."
    }
],
"tableData": [
    ["Innova Crysta Taxi Service", "SUV Taxi"],
    ["SUV Taxi Service", "SUV Cab Service"],
    ["Innova Crysta Taxi Near Me", "Innova Rent Rate"],
    ["Innova Car Taxi", "Innova Crysta Hire"],
    ["Innova 8 Seater on Rent", "Innova Cab Booking in Pune"],
    ["Book a Toyota Innova in Pune", "7 Seater Cab for Outstation"],
    ["Family Innova Crysta Taxi", "Affordable Innova Crysta Cab"],
    ["Innova Crysta Tour Package Booking", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Luxury and Comfort with Innova Crysta Taxi Service",
        "WhyChoosedescription": "Prince Cabs offers premium Innova Crysta taxi services designed for travelers who value space, comfort, and style. Our Innova Crysta taxis come with plush leather seats, ample legroom, and advanced features that make every journey enjoyable, whether it's a city ride, airport transfer, or outstation trip."
    },
    {
        "WhyChooseheading": "Well-Maintained Fleet Ensuring Safety and Cleanliness",
        "WhyChoosedescription": "Our Innova Crysta taxis are regularly serviced and thoroughly sanitized before and after each ride. Equipped with the latest safety features and modern amenities, our fleet guarantees a safe, hygienic, and reliable travel experience."
    },
    {
        "WhyChooseheading": "Experienced Drivers Providing Professional Service",
        "WhyChoosedescription": "All our drivers are professionally trained, punctual, and well-versed with city and highway routes. They prioritize your safety and comfort, ensuring courteous behavior and smooth driving throughout your journey."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Needs",
        "WhyChoosedescription": "Whether you need an Innova Crysta taxi for local travel, airport pickup/drop, or outstation tours, Prince Cabs offers customizable packages with hourly, daily, and per kilometer pricing options. Booking is easy through phone, WhatsApp, or online platforms."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our pricing structure is competitive and straightforward. We provide upfront fare estimates inclusive of all taxes, driver allowances, tolls, and parking fees, ensuring a hassle-free and trustworthy booking experience."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Seamless Travel",
        "WhyChoosedescription": "Our customer support team is available round the clock to assist you with Innova Crysta taxi bookings, route planning, and any travel-related queries, ensuring a smooth and pleasant journey every time."
    }
]





























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Innova Crysta taxi services?',
        answer: 'Yes, Prince Cabs offers Innova Crysta taxi services for local, airport, and outstation travel. It’s a premium 6–7 seater SUV perfect for comfortable group journeys.',
    },
    {
        question: 'What are the benefits of choosing an Innova Crysta taxi?',
        answer: 'Innova Crysta taxis come with spacious interiors, captain seats, dual AC, smooth suspension, and excellent legroom—ideal for long-distance and luxury travel.',
    },
    {
        question: 'What is the per km rate for Innova Crysta taxi?',
        answer: 'Our Innova Crysta taxi rates start from ₹20 per km for outstation trips. Local and airport rates are based on hourly or distance-based packages.',
    },
    {
        question: 'Is the Innova Crysta taxi suitable for family or business trips?',
        answer: 'Absolutely! Whether it’s a weekend family tour, airport transfer, or business travel, Innova Crysta provides unmatched comfort and reliability.',
    },
    {
        question: 'Are Innova Crysta taxis available 24/7?',
        answer: 'Yes, Prince Cabs operates 24/7. You can book an Innova Crysta taxi any time of day or night for immediate or scheduled trips.',
    },
    {
        question: 'Is the Innova Crysta taxi safe and clean?',
        answer: 'Yes, all Prince Cabs vehicles, including Innova Crysta, are sanitized before every ride and undergo regular maintenance. Drivers are experienced and background-verified.',
    },
    {
        question: 'How do I book an Innova Crysta taxi with Prince Cabs?',
        answer: 'Booking is easy—call our support team or visit our website. Provide your trip details, and we’ll confirm your Innova Crysta taxi quickly and transparently.',
    },
];

const testimonials = [
    {
        name: "Mr. Aniket Deshmukh",
        position: "Marketing Consultant",
        text: "Booked an Innova Crysta taxi for a Pune to Nashik trip. Super comfortable, clean, and on-time service. Prince Cabs exceeded expectations.",
        image: "/img/testimonial/testimonial-thumb-crysta-taxi-1.png",
    },
    {
        name: "Ms. Riya Mehta",
        position: "Traveler",
        text: "Prince Cabs provided a great Innova Crysta taxi for our outstation travel. Smooth booking process and professional driver. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-crysta-taxi-2.png",
    },
];




































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta Taxi",
  "image": "https://princecab.com/assets/images/innova-crysta-taxi.jpg",
  "description": "Book Innova Crysta taxi service with Prince Cabs for comfortable SUV rides, family trips, and outstation tours. Affordable rates with 7-seater luxury cab options.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.73",
    "ratingCount": "7100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2300",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/innova-crysta-taxi"
  }
};




    return (
        <div>
<Helmet>
  <title>Innova Crysta Taxi Service | 7-Seater SUV Rental | Prince Cabs</title>
  <meta
    name="description"
    content="Book Innova Crysta taxi service with Prince Cabs for comfortable SUV rides, family trips, and outstation tours. Affordable rates with luxury 7-seater cab options."
  />
  <meta
    name="keywords"
    content="Innova Crysta Taxi Service, SUV Taxi, SUV Taxi Service, SUV Cab Service, Innova Crysta Taxi Near Me, Innova Rent Rate, Innova Car Taxi, Innova Crysta Hire, Innova 8 Seater on Rent, Innova Cab Booking in Pune, Book a Toyota Innova in Pune, 7 Seater Cab for Outstation, Family Innova Crysta Taxi, Affordable Innova Crysta Cab, Innova Crysta Tour Package Booking"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/33.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovacrystataxi;